import r from "./restArguments.js";
import t from "./isFunction.js";
import o from "./_optimizeCb.js";
import m from "./allKeys.js";
import e from "./_keyInObj.js";
import i from "./_flatten.js";
var n = r(function (r, n) {
  var f = {},
    s = n[0];
  if (null == r) return f;
  t(s) ? (n.length > 1 && (s = o(s, n[1])), n = m(r)) : (s = e, n = i(n, !1, !1), r = Object(r));
  for (var p = 0, a = n.length; p < a; p++) {
    var j = n[p],
      l = r[j];
    s(l, j, r) && (f[j] = l);
  }
  return f;
});
export { n as default };